import { useEffect } from "react";
import { MARKS, LogoMark } from "../components/site/LogoMarks";
import { Logo } from "../components/site/Logo";

const Option = ({ id, m }) => (
  <div className="card-warm overflow-hidden" data-testid={`logo-option-${id}`}>
    <div className="grid grid-cols-2">
      <div className="grid place-items-center py-10 bg-white"><LogoMark mark={id} size={110} /></div>
      <div className="grid place-items-center py-10 bg-[#1E3A2B]"><LogoMark mark={id} size={110} light /></div>
    </div>
    <div className="p-6 border-t border-[#E5E0D8] space-y-5">
      <div>
        <h2 className="font-display text-xl font-semibold">{m.name}</h2>
        <p className="text-sm text-[#5A6561] mt-1">{m.desc}</p>
      </div>
      <div className="flex flex-wrap items-center gap-6">
        <Logo mark={id} />
        <div className="rounded-xl bg-[#1E3A2B] px-4 py-3"><Logo mark={id} light /></div>
        <div className="flex items-end gap-3"><LogoMark mark={id} size={32} /><LogoMark mark={id} size={20} /></div>
      </div>
    </div>
  </div>
);

export default function LogoOptions() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  return (
    <section className="container-site py-14 sm:py-20" data-testid="logo-options-page">
      <span className="eyebrow">Logo concepts</span>
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight">Choose a logo direction</h1>
      <p className="lead mt-4 max-w-2xl">Each option is shown on light and dark backgrounds, next to the wordmark, and at small sizes. Tell us which one you like, or combine ideas.</p>
      <div className="grid md:grid-cols-2 gap-6 mt-12">
        {Object.entries(MARKS).filter(([id]) => id !== "original").map(([id, m]) => <Option key={id} id={id} m={m} />)}
      </div>
    </section>
  );
}
